/** @format */

import { GET_SHARED_PREFERENCE } from "core-lib/constants/nativeBridge";
import { resetWebView } from "core-lib/utils/common";
import { passMessageToNative } from "core-lib/utils/nativeBridge";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Modal } from "ui";
import Login from "../Login";
import s from "./LoginPopup.module.scss";

export type LoginPopupProps = {
  renderWithoutModal?: boolean;
  loginPopupUpdate: (payload: any) => void;
};

export function LoginPopup({
  renderWithoutModal = false,
  loginPopupUpdate,
}: LoginPopupProps) {
  const [activeStep, setActiveStep] = useState(0);

  const { loginPopup, isAuthenticated } = useSelector((state) => state?.auth);

  const renderDetails = () => (
    <div className={s.root}>
      <div className={s.body}>
        <Login
          activeStep={activeStep}
          onStepChange={(step) => setActiveStep(step)}
          title={"Login to continue & discover"}
          subTitle={"Unlock exclusive offers just for you"}
        />
      </div>
    </div>
  );

  useEffect(() => {
    passMessageToNative(GET_SHARED_PREFERENCE, null, {
      key: "DEEPLINK_DATA",
      callbackScript:
        "window.sessionStorage.setItem('DEEPLINK_DATA', JSON.stringify(__value__))",
    });
  }, []);

  useEffect(() => {
    if (isAuthenticated && loginPopup.show) {
      loginPopupUpdate({ show: false });
    }
  }, [isAuthenticated]);

  if (renderWithoutModal) {
    return renderDetails();
  }

  if (!loginPopup.show) return null;

  return (
    <Modal
      show={loginPopup.show}
      isWeb
      head={{
        show: true,
        title: "",
        onClose: () => {
          loginPopupUpdate({ show: false });
          resetWebView();
        },
      }}
      variant="bottomSheet"
      closeOnClickOutside
      rootStyle={{ zIndex: 9999 }}
      noPadding
    >
      {renderDetails()}
    </Modal>
  );
}
